import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

import styled, { css } from "styled-components";
import { Paper } from "../Paper";

function getPosition(position) {
  switch (position) {
    case "bottom-center":
      return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                bottom: 24px;\n                left: 50%;\n                transform: translateX(-50%);\n            "])));

    case "bottom-left":
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                bottom: 24px;\n                left: 24px;\n            "])));

    case "bottom-right":
      return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                bottom: 24px;\n                right: 24px;\n            "])));

    case "top-center":
      return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                top: 24px;\n                left: 50%;\n                transform: translateX(-50%);\n            "])));

    case "top-left":
      return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                top: 24px;\n                left: 24px;\n            "])));

    case "top-right":
      return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                top: 24px;\n                right: 24px;\n            "])));
  }
}

export var ToastContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    position: fixed;\n    ", ";\n    z-index: ", ";\n"])), function (_ref) {
  var position = _ref.position;
  return getPosition(position);
}, function (p) {
  return p.theme.zIndex.toast;
});
export var ToastContent = styled(Paper)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n\n    box-sizing: border-box;\n    min-height: 56px;\n    min-width: 300px;\n    max-width: 360px;\n    padding: 14px;\n    border-radius: ", ";\n\n    ", ";\n\n    svg {\n        font-size: 18px;\n    }\n\n    @media screen and (max-width: 400px) {\n        min-width: calc(100vw - 48px);\n        max-width: calc(100vw - 48px);\n    }\n"])), function (props) {
  return props.theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type;
  var statusColor = type && type !== "loading" ? theme.palette.status[type] : undefined;
  return statusColor ? css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n                  color: white;\n                  background-color: ", ";\n              "])), statusColor) : css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n                  background-color: ", ";\n              "])), theme.palette.background);
});
export var ToastAction = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    margin-left: auto;\n"])));